// @flow
import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {useActions} from '../../../../../utils/globalStore';
import {actions} from '../duck';
import type {RootState} from '../../../..';

const logisticPickupDelivery = (state: RootState) =>
  state.logisticsConfig.pickupMethod;
const logisticShippingDelivery = (state: RootState) =>
  state.logisticsConfig.shippingMethod;

const enabledLogisticShippingSelector = (state: RootState) =>
  state.logisticShippingConfig.shippingMethods;
const enabledLogisticPickupSelector = (state: RootState) =>
  state.logisticPickupConfig.pickupMethod;

export function useEnabledLogisticShipping() {
  // const deliveryMethods = useSelector(logisticMethodsDelivery);
  const logisticPickupDeliverySelector = useSelector(logisticPickupDelivery);
  const logisticShippingDeliverySelector = useSelector(
    logisticShippingDelivery
  );

  const enabledLogisticShipping = useSelector(enabledLogisticShippingSelector);
  const enabledLogisticPickup = useSelector(enabledLogisticPickupSelector);
  const fetchDeliveryMethods = useActions(actions.fetchDeliveryMethods);

  const deliveryMethods = {
    shippingMethod: logisticShippingDeliverySelector,
    pickupMethod: logisticPickupDeliverySelector,
  };

  const getDeliveryMethods = useCallback(() => {
    return fetchDeliveryMethods();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDeliveryMethods, enabledLogisticShipping, enabledLogisticPickup]);

  return {
    deliveryMethods,
    getDeliveryMethods,
  };
}

export function useDeliveryShippingConfig() {
  const logisticShippingDeliveryConfig = useSelector(logisticShippingDelivery);

  return {logisticShippingDeliveryConfig};
}
